// Ajoute une classe stylable au bloc "Votre tarif professionnel" injecté
// par le script Wholesale Hub (aucun style ni logique de prix ici, juste
// un hook CSS car ce bloc n'a ni classe ni id côté app).
(function () {
  var TARGET_TEXT = 'Votre tarif professionnel';
  var TARGET_CLASS = 'wh-pro-tarif-label';

  function tagWholesaleLabels() {
    var divs = document.querySelectorAll('div:not(.' + TARGET_CLASS + ')');
    divs.forEach(function (div) {
      if (div.children.length === 0 && div.textContent.trim() === TARGET_TEXT) {
        div.classList.add(TARGET_CLASS);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', tagWholesaleLabels);

  var observer = new MutationObserver(tagWholesaleLabels);
  observer.observe(document.body, { childList: true, subtree: true });
})();
